import {
    TableContainer,
    Paper,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
} from '@mui/material';
import React from 'react';
interface ITableDataCompareResultProps {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    data: {
        name: string;
        value: {
            chart_number: {
                data: {
                    name: string;
                    value: number;
                    value_percent: number;
                }[];
            };
            chart_y_category: {
                category: string[];
                data: {
                    name: string;
                    value: number[];
                }[];
                data_percent: {
                    name: string;
                    value: number[];
                }[];
            };
        };
    }[];
}
const TableDataCompareResult: React.FC<ITableDataCompareResultProps> = ({
    data,
}) => {
    return (
        <TableContainer
            component={Paper}
            sx={{
                overflowX: 'auto',
            }}
        >
            <Table
                sx={{
                    minWidth: 650,
                }}
            >
                <TableHead
                    sx={{
                        backgroundColor: '#D4E3FF',
                    }}
                >
                    <TableRow>
                        <TableCell>Điều kiện</TableCell>
                        <TableCell>Câu trả lời</TableCell>
                        <TableCell>Số lượng</TableCell>
                        <TableCell>Tỷ lệ</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {data?.map((item, i) => {
                        const rows = item.value.chart_number.data;

                        return rows?.map((row, j) => (
                            <TableRow key={`${i}-${j}`}>
                                {j === 0 && (
                                    <TableCell rowSpan={rows.length}>
                                        {item.name}
                                    </TableCell>
                                )}
                                <TableCell>{row.name}</TableCell>
                                <TableCell>{row.value}</TableCell>
                                <TableCell>{row.value_percent}%</TableCell>
                            </TableRow>
                        ));
                    })}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default TableDataCompareResult;
